<i18n lang='yml' src='../i18n/Main.yml'></i18n>
<template>
  <div v-if="loading">
    <loading-animation-vue :spinnerSize="40"></loading-animation-vue>
  </div>
  
  <div v-else class="filter-bar">     
    <form class="form-inline" :action="filter_path" method="get">
       <div class="btn-toolbar">
        <div class="search-area">
          <div class="search-bg"></div>
          <span class="form-group filter-sort" v-if='components.sort && components.sort.options'>
            <label for="filter_sort" class="sr-only">Sort</label>
            <select  ref="filter_sort" id="filter_sort" name="sort" class="form-control" v-model="components.sort.value" @mouseover="changeSelect($event)">
              <option :key="item.id" v-for='item in components.sort.options' :value="item">
                {{ $t('order_by') }} {{ $t(item) }}
              </option>
            </select>
          </span>
          <span class="form-group" v-if="components.resource_type && components.resource_type.options">
            <label for="filter_resource_type" class="sr-only" >Resource_type</label>
            <select ref="filter_resource_type" id="resource_type" name="resource_type" class="form-control" v-model="components.resource_type.value" @mouseover="changeSelect($event)">
              <option :value="''" selected>{{$t("resource_type")}}</option>
              <option :key="item.id" v-for='item in components.resource_type.options' :value="item.id">
                {{ item[`name_${locale}`] }}
              </option>
            </select>
          </span>
          <span class="form-group" v-if="components.status && components.status.options">
            <label for="filter_status" hidden="true"> {{ $t('status') }}</label>
            <select ref="filter_status" id="filter_status" name="status" class="form-control" v-model="components.status.value" @mouseover="changeSelect($event)">
              <option :key="item.id" v-for='item in components.status.options' :value="item.value">
                {{ $t(item.name) }}
              </option>
              <option :value="''">
                {{ $t('status') }}
              </option>
            </select>
          </span>
        <span class="form-group" v-if="components.required && components.required.options">
          <label for="filter_required" hidden="true"> {{ $t('required') }}</label>
          <select ref="filter_required" id="filter_required" name="required" class="form-control" v-model="components.required.value" 
          @mouseover="changeSelect($event)">
            <option :key="item.id" v-for='item in components.required.options' :value="item.value">
              {{ $t(item.name) }}
            </option>
            <option :value="''">
              {{ $t('type') }}
            </option>
          </select>
        </span>
        <span class="form-group" v-if="components.exam_type && components.exam_type.options">
          <label for="filter_exam_type" hidden="true"> {{ $t('exam_type') }}</label>
          <select ref="filter_exam_type" id="filter_exam_type" name="exam_type" class="form-control" v-model="components.exam_type.value" 
          @mouseover="changeSelect($event)">
            <option :key="item.id" v-for='item in components.exam_type.options' :value="item.value">
              {{ $t(item.name) }}
            </option>
            <option :value="''">
              {{ $t('exam_type') }}
            </option>
          </select>
        </span>
        <span class="form-group" v-if="components.container && components.container.options">
          <label for="container" hidden="true"> {{ $t('container') }}</label>
          <input name="container" type="hidden" v-model="components.container.value">
          <multi-select
          :options="[{label: $t('all'), value: ''}].concat(getContainers(components.container.options))"
          :placeholder="$t('all')"
          :can-clear="false"
          class="single-select" 
          :can-deselect="false"
          v-model="components.container.value"
          label="label"
          track-by="label"
          :searchable="true"
          key="id"
          />
        </span>
        <span class="form-group" v-if='components.system_classifications' v-for='(classification_type, index) in components.system_classifications' :key="classification_type.id">
          <label name="`filter_system-classification-${index}`" :for="`filter_system-classification-${index}`" class="sr-only"></label>
          <select :ref="`filter_system-classification-${index}`" :id="`filter_system-classification-${index}`" :name="`system_classifications[${index}]`" class="form-control" @mouseover="changeSelect($event)">
            <option value="">{{ classification_type.name }} </option>
            <option :key="classification.id" v-for='classification in classification_type' :value="classification.value">
              {{ classification.name }}
            </option>
          </select>
        </span>
        <span v-if='components.search' class="form-group filter-search">
          <label for="filter_search" class="sr-only">Search</label>
          <input id="filter_search" name="search" v-model="components.search.value" :placeholder="$t('search')" type="text" class="form-control" maxlength="200">
        </span>
        </div>
        <div class="btn-group-submit ml-auto" role="group" :aria-label="$t('filter_search_buttons')">
          <a class="btn btn-secondary" :aria-label="$t('clear')" :href="currentPath">
            <font-awesome-icon :icon="['fas', 'times']" />
            {{ $t('clear_filters') }}</a>
          <button class="btn btn-primary" :aria-label="$t('filter')" type="submit">
            <font-awesome-icon :icon="['fas', 'search']" />
            {{$t('filter')}}
          </button>
          <template v-if="new_button_enabled">
            <a :class="`btn btn-success ${new_button_classes}`" :aria-label="new_button_text" href="#" :data-target="new_button_target" :data-toggle="new_button_toggle">{{ new_button_text }}</a>
          </template>
        </div>
      </div>
    </form>
  </div>
</template>


<script>
  import { sendAjaxRequest } from '../../shared/typescripts/ajax.ts'

    export default {
        props: ['filter_params', 'filter_path', 'classifiable_id', 'classifiable_type', 'new_button_enabled', 'new_button_classes', 'new_button_target', 'new_button_toggle', 'new_button_text', 'locale'],
        data() {
            return {
                components: {
                  search: { value: '' }
                },
                loading: true,
                currentPath: window.location.pathname             // save path for reloading page to clear filters
            }
        },

        
        // This ajax call sends the data to the controller so that we can know which parts of the bar to show
        // we need to send the filter_params to the controller because it contains the enabled params for what we are
        // filtering, so we need those to rebuild the proper object controller side.
        // Doing it as a POST request because with GET requests the data we are sending is too large for uri
        mounted () {
            const self = this;
            let payload = { filter_params: self.filter_params,
                            filter_path: self.filter_path,
                            classifiable_id: self.classifiable_id,
                            classifiable_type: self.classifiable_type
                          }

            sendAjaxRequest('POST', '/en/filter_bar#main', 'json', payload, this.ajaxSuccess, this.throwError);
        },
        methods: {
            getContainers(data,) {
              let newArray = [];
              data.map((item) => {
                newArray.push({value: item.id, label: item.label})
              })
              return newArray
            },
            changeSelect(event){   
                const  selected = event.target
                if(selected.options[selected.selectedIndex]) {
                  selected.setAttribute("title",selected.options[selected.selectedIndex].text)       
                }
          },
          containersSort(a,b) {
              if(a.label < b.label) {
                return -1
              }
              else if(a.label > b.label) {
                return 1
              }
              return 0
          },

          ajaxSuccess(data) {
            const self = this;
            self.components = data;
            if (self.components.system_classifications) {
                // This is needed so that the v-model initializes with the blank data when no system classifications are being filtered
                if (!self.components.system_classification_id.value) {
                    self.components.system_classification_id.value = Array(Object.keys(data.system_classifications).length).fill('')
                }
            }
            self.loading = false;
          },

          throwError() {
          console.log('There was an error with loading the filter bar')
          }
        },
    }
</script>
